import { declareString } from "@1js/localization";

export const ViewMorePrompts = declareString("promptLibrary.viewMorePrompts", {
  text: "View all prompts",
  comment:
    "Label for a button that displays right below a grid of Copilot prompts. Clicking on this button will take the user to the Copilot Lab page.",
});

export const PromptsHeading = declareString(
  "promptLibrary.explorePromptsHeading",
  {
    text: "Powerful prompts, a click away",
    comment:
      "Title for a section on the home page that displays a grid of Copilot prompts. Clicking on any prompts inside the prompt grid will bring a popup that display more information about the prompt.",
  }
);
